<template lang="pug">
DeliveryTime(
  :disable="disable",
  :mkad="mkad",
  :full="full",
  :deliveryTimes="$moscowDeliveryTimes",
  :deliveryServiceId="deliveryServiceId",
  @time="$emit('time', $event)",
  @deliveryTime="$emit('deliveryTime', $event)",
  @expressDisabled="$emit('expressDisabled', $event)"
)
</template>

<script>
import DeliveryTime from '@/steps/step4/components/DeliveryTimeIntervals.vue'

export default {
  name: 'MoscowDeliveryTime',
  components: {
    DeliveryTime,
  },
  unmounted() {
    this.$emit('commentOff')
  },
  props: {
    disable: Boolean,
    mkad: Boolean,
    full: Boolean,
    deliveryServiceId: {
      type: String,
      default: '',
    },
  },
}
</script>
